// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClientPackList {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  overflow: auto;
  position: relative;
}
.ClientPackList .SearchContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 2rem;
  padding: 0 0.75rem;
}
.ClientPackList .SearchContainer .Input {
  width: 50%;
  min-width: 10rem;
  max-width: 25rem;
  height: 100%;
  position: relative;
}
.ClientPackList .SearchContainer .Input input {
  padding: 0 2.5rem 0 0.75rem;
  width: 100%;
  height: 100%;
  background: var(--Foreground);
  color: var(--TextColor);
  border-radius: 0.5rem;
  font-size: 0.875rem;
  border: 0.0625rem solid var(--Stroke);
}
.ClientPackList .SearchContainer .Input input::placeholder {
  font-size: 0.875rem;
  letter-spacing: 0.5px;
}
.ClientPackList .SearchContainer .Input svg {
  position: absolute;
  top: 50%;
  right: 0.75rem;
  transform: translateY(-50%);
}
.ClientPackList .PackContainerWrapper {
  width: 100%;
  flex: 1 1;
  padding: 0.5rem 0.75rem 4rem 0.75rem;
  mask-image: linear-gradient(to top, transparent, var(--Background) 10%);
  overflow: auto;
}
.ClientPackList .PackContainerWrapper .PackContainer {
  flex: 1 1;
  width: 100%;
  columns: 4;
  column-gap: 1rem;
  overflow: auto;
}
.ClientPackList .PackContainerWrapper .PackContainer .Pack {
  background: var(--Foreground);
  width: 100%;
  padding: 0.75rem 0.75rem 1rem 0.75rem;
  border-radius: 0.75rem;
  margin-bottom: 1rem;
  page-break-inside: avoid;
  break-inside: avoid;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  box-shadow: 0.0625rem 0.0625rem 0.625rem 0 rgba(0, 0, 0, 0.0196078431);
  position: relative;
  cursor: default;
}
.ClientPackList .PackContainerWrapper .PackContainer .Pack h1 {
  font-size: 2rem;
  font-weight: 700;
  color: var(--TextColor);
}
.ClientPackList .PackContainerWrapper .PackContainer .Pack h3 {
  max-width: 15rem;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--AccentColor);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.ClientPackList .PackContainerWrapper .PackContainer .Pack .Checks {
  width: 100%;
  padding: 0 1rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
}
.ClientPackList .PackContainerWrapper .PackContainer .Pack .Checks span {
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--TextColor);
}
.ClientPackList .PackContainerWrapper .PackContainer .Pack .Checks svg {
  min-width: 0.75rem;
  min-height: 0.75rem;
}
.ClientPackList .PackContainerWrapper .PackContainer .Pack .Checks svg path {
  fill: var(--AccentColor);
}
.ClientPackList .PackContainerWrapper .PackContainer .Pack:hover {
  background: var(--Hover);
}
.ClientPackList .NoData {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  color: var(--TextColor);
}
.ClientPackList .LoaderContainer {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(44, 44, 44, 0.3137254902);
  z-index: 1;
}

@media (max-width: 1240px) {
  .ClientPackList .PackContainerWrapper .PackContainer {
    columns: 3;
  }
}
@media (max-width: 980px) {
  .ClientPackList .PackContainerWrapper .PackContainer {
    columns: 2;
  }
}
@media (max-width: 700px) {
  .ClientPackList .PackContainerWrapper .PackContainer {
    columns: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/ClientComponents/ClientPackList.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAEJ;AADI;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAGN;AAFM;EACE,2BAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,qCAAA;AAIR;AAFM;EACE,mBAAA;EACA,qBAAA;AAIR;AAFM;EACE,kBAAA;EACA,QAAA;EACA,cAAA;EACA,2BAAA;AAIR;AAAE;EACE,WAAA;EACA,SAAA;EACA,oCAAA;EACA,uEAAA;EACA,cAAA;AAEJ;AADI;EACE,SAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;AAGN;AAFM;EACE,6BAAA;EACA,WAAA;EACA,qCAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,sEAAA;EACA,kBAAA;EACA,eAAA;AAIR;AAHQ;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;AAKV;AAHQ;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAKV;AAHQ;EACE,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AAKV;AAJU;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAMZ;AAJU;EACE,kBAAA;EACA,mBAAA;AAMZ;AALY;EACE,wBAAA;AAOd;AAFM;EACE,wBAAA;AAIR;AAAE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;AAEJ;AAAE;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,UAAA;AAEJ;;AAGA;EAGM;IACE,UAAA;EAFN;AACF;AAQA;EAGM;IACE,UAAA;EARN;AACF;AAcA;EAGM;IACE,UAAA;EAdN;AACF","sourcesContent":[".ClientPackList{\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  overflow: auto;\n  position: relative;\n  .SearchContainer{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    width: 100%;\n    height: 2rem;\n    padding: 0 0.75rem;\n    .Input{\n      width: 50%;\n      min-width: 10rem;\n      max-width: 25rem;\n      height: 100%;\n      position: relative;\n      input{\n        padding: 0 2.5rem 0 0.75rem;\n        width: 100%;\n        height: 100%;\n        background: var(--Foreground);\n        color: var(--TextColor);\n        border-radius: 0.5rem;\n        font-size: 0.875rem;\n        border: 0.0625rem solid var(--Stroke);\n      }\n      input::placeholder{\n        font-size: 0.875rem;\n        letter-spacing: 0.5px;\n      }\n      svg{\n        position: absolute;\n        top: 50%;\n        right: 0.75rem;\n        transform: translateY(-50%);\n      }\n    }\n  }\n  .PackContainerWrapper{\n    width: 100%;\n    flex: 1;\n    padding: 0.5rem 0.75rem 4rem 0.75rem;\n    mask-image: linear-gradient(to top, transparent, var(--Background) 10%);\n    overflow: auto;\n    .PackContainer{\n      flex: 1;\n      width: 100%;\n      columns: 4;\n      column-gap: 1rem;\n      overflow: auto;\n      .Pack{\n        background: var(--Foreground);\n        width: 100%;\n        padding: 0.75rem 0.75rem 1rem 0.75rem;\n        border-radius: 0.75rem;\n        margin-bottom: 1rem;\n        break-inside: avoid;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 0.75rem;\n        box-shadow: 0.0625rem 0.0625rem 0.625rem 0 #00000005;\n        position: relative;\n        cursor: default;\n        h1{\n          font-size: 2rem;\n          font-weight: 700;\n          color: var(--TextColor);\n        }\n        h3{\n          max-width: 15rem;\n          font-size: 1.25rem;\n          font-weight: 700;\n          color: var(--AccentColor);\n          white-space: nowrap;\n          text-overflow: ellipsis;\n          overflow: hidden;\n        }\n        .Checks{\n          width: 100%;\n          padding: 0 1rem;\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          gap: 0.75rem;\n          span{\n            font-size: 0.875rem;\n            font-weight: 400;\n            color: var(--TextColor);\n          }\n          svg{\n            min-width: 0.75rem;\n            min-height: 0.75rem;\n            path{\n              fill: var(--AccentColor);\n            }\n          }\n        }\n      }\n      .Pack:hover{\n        background: var(--Hover);\n      }\n    }\n  }\n  .NoData{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    color: var(--TextColor);\n  }\n  .LoaderContainer{\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #2C2C2C50;\n    z-index: 1;\n  }\n}\n\n\n@media (max-width: 1240px) {\n  .ClientPackList{\n    .PackContainerWrapper{\n      .PackContainer{\n        columns: 3;\n      }\n    }\n  }\n}\n\n\n@media (max-width: 980px) {\n  .ClientPackList{\n    .PackContainerWrapper{\n      .PackContainer{\n        columns: 2;\n      }\n    }\n  }\n}\n\n\n@media (max-width: 700px) {\n  .ClientPackList{\n    .PackContainerWrapper{\n      .PackContainer{\n        columns: 1;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
